"use strict";

exports.__esModule = true;
exports.default = withForwardRef;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _wrapDisplayName = _interopRequireDefault(require("recompose/wrapDisplayName"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function withForwardRef(WrappedComponent) {
  var Wrapper = (0, _react.forwardRef)(function (props, ref) {
    return (0, _core.jsx)(WrappedComponent, _extends({}, props, {
      forwardedRef: ref
    }));
  });
  Wrapper.displayName = (0, _wrapDisplayName.default)(WrappedComponent, 'WithForwardRef'); // $FlowFixMe - defaultProps missing in React.AbstractComponentStatics

  Wrapper.defaultProps = WrappedComponent.defaultProps; // $FlowFixMe - defaultProps missing in React.AbstractComponentStatics

  Wrapper.propTypes = WrappedComponent.propTypes;
  (0, _hoistNonReactStatics.default)(Wrapper, WrappedComponent);
  return Wrapper;
}